<template>
    <div class="">
        <draggable
            class="magazine-pages-sorted-draggable"
            group="pageorder"
            ghost-class="ghost"
            :list="pages"
            @change="orderChanged">
            <div
                class="pageorder"
                v-for="page in pages"
                v-if="showPage(page.order)"
                :key="page.id">
                <img :src="page.thumb" />

                <div class="page-info">
                    <div class="page-title">{{ page.title }}</div>
                    <div class="page-number">{{ page.order }}</div>
                </div>
            </div>
        </draggable>
    </div>
</template>

<script>
import draggable from 'vuedraggable';

export default {
    name: 'design-2021-magazine-page-order-component',
    components: {
        draggable,
    },
    data() {
        return {
            pages: this.pagesIn,
        };
    },
    props: ['magazineId', 'pagesIn', 'version'],
    methods: {
        showPage(order) {
            if (order == 1 || order == this.pages.length) {
                return false;
            }

            if (
                (this.version == 'garenloos' || this.version == 'hardbound') &&
                (order == 2 || order == this.pages.length - 1)
            ) {
                return false;
            }

            return true;
        },
        orderChanged() {
            let array = [];
            let count = 0;

            for (const page of this.pages) {
                count++;
                array.push({
                    id: page.id,
                    order: count,
                });
            }

            const data = {
                blocks: array,
            };

            this.axios.post(this.routes.magazineOrderChanged(this.magazineId), data).then(
                (response) => {
                    this.alert.success(
                        this.$t('magazine.order_has_been_edited'),
                        this.$t('magazine.changed_the_order_of_pages'),
                    );
                }, // no action required
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss">
.magazine-pages-sorted-draggable {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: flex-start;
}

.pageorder {
    margin: 0 map-get($grid-gutter-spacing, 'fifteen') map-get($grid-gutter-spacing, 'twenty-one')
        map-get($grid-gutter-spacing, 'fifteen');
    position: relative;

    img {
        width: 120px;
        height: 170px;
    }

    .page-info {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        bottom: 0;
        background: $primary;
        width: 100%;
        height: 35px;
        transition: all 0.3s ease;

        .page-title {
            opacity: 0;
            top: 0;
            color: $white;
            font-size: $base-font-size;
            text-align: center;
        }

        .page-number {
            color: $white;
            text-align: center;
            font-size: $base-font-size;
            line-height: 1;
            padding: map-get($grid-gutter-spacing, 'eight') 0;
            position: absolute;
            bottom: 0;
        }
    }

    &:hover {
        cursor: pointer;

        .page-info {
            height: 100%;
            background: lighten($magazine-page-hover-color, 15%);

            .page-title {
                top: 40%;
                opacity: 1;
            }
        }
    }
}

.ghost {
    background-color: darken($secondary-background-color, 10%);
}
</style>
